import React from 'react';
import ButtonLink, {
  Props as ButtonLinkProps,
} from '@teetsh/app/src/components/Buttons/Link';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';

interface Props {
  to: string;
}

export default function SchoolyearButtonLink(
  props: Props & ButtonLinkProps & { withSchoolContext?: boolean },
) {
  const { to, withSchoolContext = true, ...rest } = props;
  const { schoolyear, school } = useSchoolSchoolyear();
  return (
    <ButtonLink
      to={
        withSchoolContext
          ? `/annee-scolaire/${schoolyear.id}/ecole/${school.id}/${to}`
          : to
      }
      {...rest}
    />
  );
}
